import { createContext } from "react";

/**
 * Where a summary's polite live region goes when the summary sits inside a container that can hide
 * it. GuidedTaskTemplate's rail collapses to a closed `<details>` from 1024 to 1279px, and a closed
 * disclosure drops its content from the accessibility tree, live regions included, so TaskSummary
 * renders its announcements into this element, kept outside the disclosure (Codex on #8305).
 * Null outside a host: the summary keeps them inline.
 */
export const TaskSummaryLiveHostContext = createContext<HTMLElement | null>(null);
